import { start } from "repl";

export const API_URL = {
  domain: process.env.REACT_APP_API_URL,
  auth: {
    me: "/api/auth/me",
    login: "/api/auth/login",
    logout: "/api/auth/logout",
    refreshSession: "/api/auth/refresh_session",
    //ToDo temporary
    conditions: "/api/user_conditions",
  },
  users: {
    getMany: "/api/users/get_many",
    createOne: "/api/users/create",
    getOne: "/api/users",
    updateOne: "/api/users",
    deleteOne: "/api/users",
    updateAvatar: "/api/users/update_avatar",
    deleteAvatar: "/api/users/delete_avatar",
  },
  vendors: {
    getMany: "/api/vendors/get_many",
    createOne: "/api/vendors/create",
    getOne: "/api/vendors",
    updateOne: "/api/vendors",
    deleteOne: "/api/vendors",
  },
  mrnCategories: {
    getMany: "/api/mrn_categories/get_many",
    createOne: "/api/mrn_categories",
    getOne: "/api/mrn_categories",
    updateOne: "/api/mrn_categories",
    deleteOne: "/api/mrn_categories",
  },
  nonInventory: {
    getMany: "/api/inventory/requests/get_many",
    getOne: "/api/inventory/requests",
    updateOne: "/api/inventory/requests",
    createOne: "/api/inventory/requests",
    deleteOne: "/api/inventory/requests",
  },
  inventory: {
    samples: {
      importFile: "/api/inventory/samples/import_file",
      getFileTemplate: "/api/inventory/samples/get_file_template",
      createOne: "/api/inventory/samples/create",
      getOne: "/api/inventory/samples",
      updateOne: "/api/inventory/samples",
      deleteOne: "/api/inventory/samples",
      getMany: "/api/inventory/samples/get_many",
      customRequest: "/api/inventory/samples/custom_request",
      setPrice: "/api/inventory/samples/set_batch_price",
      export: "/api/inventory/samples/export-csv",
    },
    swabs: {
      getMany: "/api/inventory/swabs/get_many",
    },
    infectiousDonors: {
      create: "/api/inventory/infectious_blood_samples/create",
      getOne: "/api/inventory/infectious_blood_samples",
      getMany: "/api/inventory/infectious_blood_samples/get_many",
    },
    infectiousAliquots: {
      create: "/api/inventory/infectious_aliquots/create",
      getMany: "/api/inventory/infectious_aliquots/get_many",
      getOne: "/api/inventory/infectious_aliquots",
    },
    infectiousAdditionalTests: {
      create: "/api/inventory/infectious_additional_tests/create",
      getOne: "/api/inventory/infectious_additional_tests",
    },
    invoices: {
      createOne: "/api/inventory/invoices/create",
      getOne: "/api/inventory/invoices",
      updateOne: "/api/inventory/invoices",
      deleteOne: "/api/inventory/invoices",
      getMany: "/api/inventory/invoices/get_many",
    },
  },
  storageFacilities: {
    createOne: "/api/storage_facilities",
    getOne: "/api/storage_facilities",
    updateOne: "/api/storage_facilities",
    deleteOne: "/api/storage_facilities",
    getMany: "/api/storage_facilities/get_many",
  },
  clientCompanies: {
    createOne: "/api/client_companies/create",
    getOne: "/api/client_companies",
    updateOne: "/api/client_companies",
    deleteOne: "/api/client_companies",
    getMany: "/api/client_companies/get_many",
    shippingLocations: {
      getMany: "/api/client_companies/shipping_locations/get_many",
      updateOne: "/api/client_companies/shipping_locations",
      createOne: "/api/client_companies/shipping_locations",
      deleteOne: "/api/client_companies/shipping_locations",
    },
    carriers: {
      getMany: "/api/client_companies/postal_accounts/get_all",
      updateOne: "/api/client_companies/postal_accounts",
      createOne: "/api/client_companies/postal_accounts",
      deleteOne: "/api/client_companies/postal_accounts",
    },
  },
  researchAreas: {
    getAll: "/api/research_areas/get_all",
    items: {
      getMany: "/api/research_areas/items/get_many",
    },
    biomarkers: {
      getMany: {
        start: "/api/research_areas/items/",
        end: "/get_loinc_biomarkers",
      },
    },
  },
  panels: {
    getAll: "/api/panels",
  },
  clientOrders: {
    getOne: "/api/client_orders",
    getMany: "/api/client_orders/get_many",
    createCart: "/api/client_orders/create_cart",
    addItemToCart: {
      start: "/api/client_orders/",
      end: "/add_item_to_cart",
    },
    addInfectiousItemToCart: {
      start: "/api/client_orders/",
      end: "/add_infectious_item_to_cart",
    },
    removeItemFromCart: {
      start: "/api/client_orders/",
      end: "/remove_item_from_cart",
    },
    removeInfectiousItemFromCart: {
      start: "/api/client_orders/",
      end: "/remove_infectious_item_from_cart",
    },
    removeAllItemFromCart: {
      start: "/api/client_orders/",
      end: "/clear_cart",
    },
    infectiousOrderItems: {
      start: "/api/client_orders/",
      end: "/infectious_order_items",
    },
    placeOrder: {
      start: "/api/client_orders/",
      end: "/place",
    },
    placeCustomRequest: "/api/client_orders/place_by_custom_request",
    manageOrder: {
      start: "/api/client_orders/",
      end: "/manage",
    },
    addItemsByCustomRequest: {
      start: "/api/client_orders/",
      end: "/add_items_by_custom_request",
    },
    createOrderShipment: {
      start: "/api/client_orders/",
      end: "/shipments",
    },
    assignOrder: {
      start: "/api/client_orders/",
      end: "/assign",
    },
  },
  loincBiomarker: {
    getMany: "/api/loinc_biomarkers/get_many",
    getOne: "/api/loinc_biomarkers",
    updateOne: "/api/loinc_biomarkers",
    loincRanges: {
      createOne: "/api/loinc_ranges",
      deleteOne: "/api/loinc_ranges",
    },
  },
  contactUs: {
    getMany: "/api/contact_us/get_chat_list",
    getOne: "/api/contact_us/get_chat_messages",
    deleteOne: "/api/contact_us",
    updateOne: "/api/contact_us/create_reply",
    createMessageAuthorized: "/api/contact_us/create_message_authorized",
  },
  sampleDistributions: {
    getDistribution: "/api/sample_distributions/get_distribution",
  },
  utils: {
    presignedUrl: "/api/utils/get-presigned-url",
  }
};

// export const SELECTED_THEME = "selected_theme";

// export const SELECTED_SCALE_FONT_SIZE = "selected_scale_font_size";

// export const SELECTED_FONT_FAMILY = "selected_font_family";

// export const SELECTED_LETTER_SPACING = "selected_letter_spacing";

// export const REMINDERS_CONTENT_DISPLAYING = "reminders_content_displaying";

// export const IS_SHOWN_COOKIES = "is_shown_cookies";

// export const IS_SHOWN_GREETING_MODAL = "is_shown_greeting_modal";
